import { DateFields } from '@sigma-frontend-libs/commons'

import render from './render'

export default {
  name: 'DateRange',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    fields() {
      return {
        [DateFields.startsAt]: this.value?.gte,
        [DateFields.endsAt]: this.value?.lt
      }
    }
  },

  render
}
